<template>
  <div class="edit-button-container toggle" @click="!disabled && $emit('click')">
    <img 
      src="@/assets/images/editBtn.png"
      class="edit-icon"
      :title="title"
      :class="{ 'disabled': disabled }"
      alt="編集"
    />
    <!-- <span class="edit-text">{{ buttonText }}</span> -->
  </div>
</template>

<script>
export default {
  name: 'EditButton',
  props: {
    title: {
      type: String,
      default: '編集'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.edit-button-container {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 8px 12px;
  color: #000000;
  font-size: 18px;
  font-weight: 500;
}

.edit-text {
  color: #3C3C3C;
  font-size: 12px;
}

.edit-icon {
  cursor: pointer;
  transition: opacity 0.2s ease;
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.edit-icon:hover {
  opacity: 0.6;
}

.edit-icon.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.edit-icon.disabled:hover {
  opacity: 0.6;
}
</style> 